module.exports = __webpack_public_path__ + "img/logo.a143d5f4.png";